<template>
  <div
    :style="{ backgroundColor: severityColor(alert.severity) }"
    class="text-center pa-2"
    style="color: white; font-size: 14px; width: 100%"
  >
    <v-icon :icon="severityIcon(alert.severity)" class="mr-2" size="small" />
    <span>{{ alert.message }}</span>
  </div>
</template>

<script setup lang="ts">
// Severity values mirror AlertSeverity enum: Info=0, Warning=1, Critical=2
defineProps<{
  alert: {
    systemAlertId: number | null;
    message: string | null;
    severity: number | null;
  };
}>();

function severityColor(severity: number | null): string {
  if (severity === 1) return "#F57C00"; // Warning
  if (severity === 2) return "#8B0000"; // Critical
  return "#1976D2"; // Info (default)
}

function severityIcon(severity: number | null): string {
  if (severity === 1) return "fa-solid fa-triangle-exclamation";
  if (severity === 2) return "fa-solid fa-circle-exclamation";
  return "fa-solid fa-circle-info";
}
</script>
